/* Three viewer states — light, dark, and "match system", which defers to
   whatever the host has stamped on <html> or to prefers-color-scheme when
   nothing has. Lifted out of the single-file build unchanged in behaviour. */

import { readStorage, writeStorage } from './engine/storageKeys.js';

let hostTheme = typeof document !== 'undefined'
  ? document.documentElement.getAttribute('data-theme')
  : null;
let writing = false;
const listeners = new Set();

export function storedTheme() {
  try { return readStorage('theme'); } catch { return null; }
}
function remember(mode) {
  try { writeStorage('theme', mode); } catch { /* choice just will not persist */ }
}

export function applyTheme(mode, persist = true) {
  const m = mode === 'light' || mode === 'dark' ? mode : 'system';
  const root = document.documentElement;
  writing = true;
  if (m === 'system') {
    if (hostTheme) root.setAttribute('data-theme', hostTheme);
    else root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', m);
  }
  setTimeout(() => { writing = false; }, 0);
  if (persist) remember(m);
  for (const l of listeners) l(m);
  return m;
}

/** Fires whenever the resolved palette may have changed, for any of the three
 *  reasons: our own toggle, the OS setting, or the host restamping the root. */
export function onThemeChange(fn) {
  listeners.add(fn);
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const onMq = () => fn(storedTheme() || 'system');
  mq.addEventListener?.('change', onMq);

  const mo = new MutationObserver(() => {
    if (writing) return;
    hostTheme = document.documentElement.getAttribute('data-theme');
    fn(storedTheme() || 'system');
  });
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });

  return () => {
    listeners.delete(fn);
    mq.removeEventListener?.('change', onMq);
    mo.disconnect();
  };
}

export function initTheme() {
  return applyTheme(storedTheme() || 'system', false);
}
